import api from './api';
import types from './mutation-types';

export default {
	setStateApprInfoSave_({ commit }, { key, value }) {
		commit(types.APPR_REASON_INFO, { key, value });
	},
	saveApprReason_({ commit, state }, payload) {
		//param, .//
		return api
			.saveApprReason(state)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'pwaApcnSwapPartsList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
